import React from "react";
import PropTypes from "prop-types";
import { Map } from "immutable";
import { Select, Tag, Icon, Modal, Button } from "antd";
import Input from "antd/lib/input";
import Row from "antd/lib/row";
import Col from "antd/lib/col";
import TableFiltersForm from "forms/table-filters-form";
import { TABLE_DATA_TYPES } from "constants/table-data-types";
import "styles/table-filters.css";
// import _isEqual from "lodash/isEqual";s

const SelectOption = Select.Option;
const InputGroup = Input.Group;

function parseFilterRawValue(filterEntry) {
    if (filterEntry == null) {
        return null;
    }
    let value = Array.isArray(filterEntry) ? filterEntry[0] : filterEntry;
    if (typeof value === "string" && value.startsWith("[")) {
        try {
            value = JSON.parse(value);
        } catch (e) {
            // keep string as-is
        }
    }
    return value;
}

class TableFilters extends React.Component {
    state = {
        open: false,
        modalVisible: false,
    };

    static buildFilterTokens(filters, columns) {
        const tokens = [];

        Object.keys(filters || {}).forEach(key => {
            const column =
                columns && columns.find
                    ? columns.find(col => (col.searchKey || col.key) === key)
                    : null;
            const value = parseFilterRawValue(filters[key]);
            const columnTitle = (column && column.title) || key;

            if (value == null || value === "") {
                return;
            }

            if (
                Array.isArray(value) &&
                column &&
                column.enums &&
                column.dataType === TABLE_DATA_TYPES.ENUM
            ) {
                value.forEach(item => {
                    const enumLabel =
                        column.enums.findKey(
                            enumVal =>
                                enumVal === Number(item) ||
                                String(enumVal) === String(item)
                        ) || item;
                    tokens.push({
                        tokenId: `${key}::${item}`,
                        label: `${columnTitle}: ${enumLabel}`,
                        filterKey: key,
                        filterValue: String(item),
                    });
                });
                return;
            }

            let displayText = "";
            if (Array.isArray(value)) {
                displayText = value.join(", ");
            } else if (typeof value === "object") {
                const min =
                    value.min && value.min._isAMomentObject
                        ? value.min.format("DD/MM/YYYY")
                        : value.min;
                const max =
                    value.max && value.max._isAMomentObject
                        ? value.max.format("DD/MM/YYYY")
                        : value.max;
                displayText = `${min || ""} - ${max || ""}`;
            } else if (column && column.enums && column.dataType === TABLE_DATA_TYPES.ENUM) {
                displayText =
                    column.enums.findKey(
                        enumVal =>
                            enumVal === Number(value) ||
                            String(enumVal) === String(value)
                    ) || value;
            } else {
                displayText = String(value);
            }

            tokens.push({
                tokenId: key,
                label: `${columnTitle}: ${displayText}`,
                filterKey: key,
            });
        });

        return tokens;
    }

    getFilterTokens = () =>
        TableFilters.buildFilterTokens(this.props.filters, this.props.columns);

    getColumnByKey(key) {
        const { columns } = this.props;
        if (!columns || !columns.find) {
            return null;
        }
        return columns.find(col => (col.searchKey || col.key) === key);
    }

    getEnumLabel(enums, value) {
        const numericValue = Number(value);
        return (
            enums.findKey(
                enumVal =>
                    enumVal === numericValue || String(enumVal) === String(value)
            ) || value
        );
    }

    getFilterDisplayText(key) {
        const column = this.getColumnByKey(key);
        const value = parseFilterRawValue(this.props.filters[key]);

        if (value == null || value === "") {
            return "";
        }

        if (Array.isArray(value)) {
            if (column && column.enums && column.dataType === TABLE_DATA_TYPES.ENUM) {
                return value.map(v => this.getEnumLabel(column.enums, v)).join(", ");
            }
            return value.join(", ");
        }

        if (typeof value === "object") {
            const min =
                value.min && value.min._isAMomentObject
                    ? value.min.format("DD/MM/YYYY")
                    : value.min;
            const max =
                value.max && value.max._isAMomentObject
                    ? value.max.format("DD/MM/YYYY")
                    : value.max;
            return `${min || ""} - ${max || ""}`;
        }

        if (column && column.enums && column.dataType === TABLE_DATA_TYPES.ENUM) {
            return this.getEnumLabel(column.enums, value);
        }

        return String(value);
    }
    getFilterValue(key) {
        const column = this.getColumnByKey(key);
        const value = parseFilterRawValue(this.props.filters[key]);

        if (value == null || value === "") {
            return null;
        }

        if (
            Array.isArray(value) &&
            column &&
            column.enums &&
            column.dataType === TABLE_DATA_TYPES.ENUM
        ) {
            return value.map(item => (
                <Tag key={item} color="#f50" style={{ marginBottom: 4 }}>
                    {this.getEnumLabel(column.enums, item)}
                </Tag>
            ));
        }

        const displayText = this.getFilterDisplayText(key);
        if (!displayText) {
            return null;
        }
        return <Tag color="#f50">{displayText}</Tag>;
    }

    normalizeFormFieldValue(filterEntry) {
        const value = parseFilterRawValue(filterEntry);

        if (value == null || value === "") {
            return undefined;
        }

        if (Array.isArray(value)) {
            return value.map(String);
        }

        if (typeof value === "object" && (value.min !== undefined || value.max !== undefined)) {
            return [value.min, value.max];
        }

        return value;
    }

    onRemoveFilterToken = tokenId => {
        const tokenKey =
            tokenId && typeof tokenId === "object" ? tokenId.key : tokenId;

        if (!tokenKey || !String(tokenKey).includes("::")) {
            this.props.applyFilters({
                ...this.props.filters,
                [tokenKey]: [],
            });
            return;
        }

        const separatorIndex = String(tokenKey).indexOf("::");
        const filterKey = String(tokenKey).slice(0, separatorIndex);
        const valueToRemove = String(tokenKey).slice(separatorIndex + 2);
        const currentValue = parseFilterRawValue(this.props.filters[filterKey]);
        const updatedValues = (Array.isArray(currentValue) ? currentValue : []).filter(
            item => String(item) !== valueToRemove
        );

        this.props.applyFilters({
            ...this.props.filters,
            [filterKey]: updatedValues.length ? [updatedValues] : [],
        });
    };

    updateFilters = values => {
        const filters = new Map(values)
            .filter(_ => !!_)
            .map((value, key) => {
                const column = this.getColumnByKey(key);
                if (
                    Array.isArray(value) &&
                    column &&
                    column.dataType === TABLE_DATA_TYPES.ENUM
                ) {
                    return [value];
                }
                if (Array.isArray(value) && value.length === 2) {
                    return [
                        {
                            min: value[0],
                            max: value[1]
                        }
                    ];
                }
                return [value];
            });
        this.props.applyFilters({ ...this.props.filters, ...filters.toJS() });
        this.setState({
            modalVisible: false
        });
    };
    renderModal() {
        return (
            <Modal
                visible={this.state.modalVisible}
                width={"800px"}
                closable
                footer={null}
                // onOk={this.toggleModal}
                onCancel={this.toggleModal}>
                <TableFiltersForm
                    ref={node => (this.modalForm = node)}
                    columns={this.props.columns}
                    submit={this.updateFilters}
                    values={new Map(this.props.filters).map(filterEntry =>
                        this.normalizeFormFieldValue(filterEntry)
                    )}
                />
            </Modal>
        );
    }
    onSearchString = str => {
        this.searchString = str;
        // this.setState({
        //     isSearchStringEditing: true,
        //     filters: { ...this.state.filters, ["search"]: [str] },
        //     selectValues: this.state.selectValues.find(_ => _ === "search")
        //         ? this.state.selectValues
        //         : [...this.state.selectValues, "search"]
        // });
    };
    onPressEnter = e => {
        if (e.keyCode === 13) {
            this.select.blur();
        }
    };
    onBlur = () => {
        this.props.applyFilters({
            ...this.props.filters,
            search: this.searchString
                ? [this.searchString]
                : this.props.filters.search
        });
        this.searchString = "";
    };
    onClear = () => {
        this.props.applyFilters({
            ...new Map(this.props.filters).map(() => []).toJS()
        });
    };
    render() {
        const { columns, hideColumnFiltersModal} = this.props;
        const filterTokens = this.getFilterTokens();
        return (
            <div className={"d-flex align-items-center"}>
                {this.renderModal()}
                <InputGroup>
                    <Row>
                        
                        <Col span={22}>
                            <Select
                                className={"mr-5 table-filters-select"}
                                allowClear
                                autoClearSearchValue
                                style={{ width: "100%" }}
                                mode={"multiple"}
                                labelInValue
                                value={filterTokens.map(token => ({
                                    key: token.tokenId,
                                    label: token.label,
                                }))}
                                placeholder={"Filters"}
                                onDeselect={this.onRemoveFilterToken}
                                optionLabelProp={"title"}
                                open={false}
                                onSearch={this.onSearchString}
                                onBlur={this.onBlur}
                                onInputKeyDown={this.onPressEnter}
                                ref={node => (this.select = node)}
                                clearIcon={
                                    <Icon
                                        type={"close-circle"}
                                        onClick={this.onClear}
                                    />
                                }>
                                {columns
                                    // .filter(_ => _.filterDropdown)
                                    .map(_ => (
                                        <SelectOption
                                            key={_.searchKey || _.key}
                                            value={_.searchKey || _.key}
                                            title={`${_.title}: ${this.getFilterDisplayText(_.searchKey || _.key)}`}
                                            className="d-flex justify-content-space-between align-items-center">
                                            <span className="table-filters-option-label">
                                                {_.title}
                                            </span>
                                            {this.getFilterValue(_.searchKey || _.key)}
                                        </SelectOption>
                                    ))
                                    .toList()
                                    .toArray()}
                                <SelectOption
                                    key={"search"}
                                    value={"search"}
                                    title={`Search: ${this.getFilterDisplayText("search")}`}
                                    className="d-flex justify-content-space-between align-items-center">
                                    <span className="table-filters-option-label">Search</span>
                                    {this.getFilterValue("search")}
                                </SelectOption>
                            </Select>
                        </Col>
                        <Col span={2}>
                            {!hideColumnFiltersModal && <Button  onClick={this.toggleModal}>
                                <Icon type={"filter"} />
                            </Button>}
                        </Col>
                    </Row>
                </InputGroup>
                
                {/* <div className={"w-100 mr-5"}>
                    
                </div> */}
            </div>
        );
    }
    toggleModal = () => {
        this.setState({
            modalVisible: !this.state.modalVisible
        });
    };
}

TableFilters.propTypes = {
    columns: PropTypes.object, //Immutable Ordered Map
    applyFilters: PropTypes.func,
    filters: PropTypes.object,
    hideColumnFiltersModal : PropTypes.bool
};

export default TableFilters;
